import { useEffect, useState } from "react";
import { navItems, tickerItems } from "@/mocks/home";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const marquee = [...tickerItems, ...tickerItems];

  return (
    <>
      {/* 更新条压顶 */}
      <div className="w-full bg-foreground-950 text-background-50">
        <div className="mx-auto flex w-full max-w-[1400px] items-center gap-3 px-4 py-2 md:px-8">
          <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-2.5 py-0.5 text-[11px] font-medium tracking-wide text-background-50">
            <i className="ri-flashlight-fill text-[11px]" />
            实时更新
          </span>
          <div className="relative h-5 flex-1 overflow-hidden">
            <div className="ticker-track flex w-max items-center gap-10 whitespace-nowrap">
              {marquee.map((item, index) => (
                <span
                  key={`${item.time}-${index}`}
                  className="flex items-center gap-2 text-xs text-background-200"
                >
                  <span className="text-accent-400">{item.time}</span>
                  {item.text}
                </span>
              ))}
            </div>
          </div>
          <span className="hidden shrink-0 items-center gap-1.5 text-[11px] tracking-wide text-background-300 md:flex">
            <i className="ri-database-2-line" />
            材料索引 v2.4
          </span>
        </div>
      </div>

      {/* 品牌导航 */}
      <header
        className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
          scrolled
            ? "border-b border-background-300/70 bg-background-50/95 backdrop-blur"
            : "border-b border-transparent bg-background-50/80 backdrop-blur"
        }`}
      >
        <div className="mx-auto flex w-full max-w-[1400px] items-center justify-between gap-4 px-4 py-3 md:px-8">
          <a href="#top" className="flex items-center gap-3" title="黑料曝光 首页">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-bold text-background-50">
              黑
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
                黑料曝光
              </span>
              <span className="text-[10px] tracking-[0.28em] text-secondary-500">
                HOT EXPOSE
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#submit"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
            >
              我要爆料
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
            >
              <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`} />
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="border-t border-background-200 bg-background-50 lg:hidden">
            <nav className="mx-auto grid w-full max-w-[1400px] grid-cols-2 gap-2 px-4 py-4 md:px-8">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="rounded-md bg-secondary-50 px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-secondary-100"
                >
                  {item.label}
                </a>
              ))}
              <a
                href="#submit"
                onClick={() => setMenuOpen(false)}
                className="col-span-2 rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50"
              >
                我要爆料
              </a>
            </nav>
          </div>
        )}
      </header>
    </>
  );
}